

  export const StaticData = [



        {
          id: 0,
          title: "Disability Content Consulting",
          images:( process.env.PUBLIC_URL +  "/assets/images/repos/dcc_main.png"),
          alt: "video background depicting NYC night time buildings",
          repo:"https://www.github.com/Kuiil7/dcc",
          demo:"https://kuiil7.github.io/dcc/",
          description: "A collective formed by talented Disabled content creators and accessibility inclusion specialists from across the globe.",
          myDuty:"Sole maintianer",
          builtWith: "Bulma, FontAwesome, React-Player, Google Fonts, and Accessibility.",
          url: null,
          status: "Ongoing"

          },
        {
          id: 1,
          title: "ErrandFolks",
          images: ( process.env.PUBLIC_URL + "/assets/images/repos/errandfolks.png"),
          alt: "landing page with a video showing a man holding a cart witha mask",
          repo:   "https://github.com/Kuiil7/errandfolks" ,
          demo:"https://sad-spence-4b83df.netlify.app",
          description: "Volunteer-based delivery services to deaf elders and immunocompromised. (discontinued due to COVID)",myDuty: "Sole maintainer.",
          builtWith: "Bulma.",
          url:"N/A",
          status: "Suspended"
            },
            {
              id: 2,
              title: "Turtle Island Hand Talk (TIHT)",
              images:  process.env.PUBLIC_URL + "/assets/images/repos/tiht.png",
              alt: "yellow/white landing page with two videos - large turtle and a female",
              repo: "http://www.tiht.org",
              demo:"http://www.tiht.org",
              description: "Turtle Island Hand Talk website - Educating, empowering, advocating, encouraging peace & promoting international understanding through our Indigenous people (Deaf and all) in North America.",
              builtWith: "WordPress",
              url: null,
              status: null
                },


  ];

